// extracted by mini-css-extract-plugin
module.exports = {"ContentWrapper":"_2zO1L8TI","tabMenuWrapper":"_3uPBeMi2","tabContentWrapper":"_2_wFSxCI","tabsMenu":"_2KjaRAWG"};